import React from 'react';
import '../css/home.css';
// Importation d'une image
import profilePic from '../imgs/profile-pic.jpg'
import Seo from './Seo';

function Home() {
  return (
    <div className="wrapper">
      <Seo
        path="/"
        description="Portfolio of Nicolas Carriere, a bilingual (French/English) Franco-Ontarian computer programmer and Collège La Cité graduate. Projects, skills and contact."
      />
      <div className="about-container">
        <div className="profile-name-container">
          <img src={profilePic} alt="Nicolas Carriere in front of Parliament Hill in Ottawa" className='profile'/>
        </div>
        <div className="description-container">
          <h1>Let me introduce myself</h1>
          <p>
            👋 Hi there! I'm Nicolas, a passionate computer programmer and proud Franco-Ontarian. Fluent in both French and English, I'm a bilingual tech enthusiast with a focus on programming, ready to embark on an exciting journey.
          </p>
          <p>
            🎨 At just 23 years old, I've already embraced my uniqueness – I have ADHD, which I consider not a weakness but a strength. It fuels my creativity and innovative thinking, providing me with a constant flow of ideas for future projects.
          </p>
          <p>
            💻 My heart belongs to technology. I discovered this love at a young age while immersing myself in video games. The realization that I could create programs to entertain, educate, and assist others was a game-changer. I find immense joy in creating software, whether it's through a fun game or a useful application.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
